import { ReactNode, useState } from 'react';
import { EnergySavingIcon, PowerRCIcon } from '~/icons';
import { RemoteControlReason } from 'providers/types/remoteControl';
import { colors } from 'styles/remoteControlColors';

interface UseReasonsInfoResponse {
  openReasonModal: boolean;
  reasonsList: RemoteControlReason[];
  iconModal: ReactNode;
  titleModal: string;
  mode: Mode | undefined;
  onOpenReasonModal: (mode: Mode) => void;
  onCloseReasonModal: () => void;
}

type Mode = 'on' | 'off' | 'economyModeDisabled';

export function useReasonsModalInfo(): UseReasonsInfoResponse {
  const [openReasonModal, setOpenReasonModal] = useState(false);
  const [options, setOptions] = useState<{
    reasonsList: RemoteControlReason[],
    titleModal: string,
    iconModal: ReactNode,
    mode: Mode | undefined
  }>({
    reasonsList: [],
    titleModal: '',
    iconModal: null,
    mode: undefined,
  });

  function onOpenReasonModal(mode: Mode): void {
    setOptions(() => {
      switch (mode) {
        case 'on': {
          return {
            iconModal: <PowerRCIcon color={colors.Black} />,
            reasonsList: [
              RemoteControlReason.COLD,
              RemoteControlReason.HOT,
              RemoteControlReason.MAINTENANCE,
              RemoteControlReason.OUT_SCHEDULE,
              RemoteControlReason.OTHER,
            ],
            titleModal: 'Ligar Máquina',
            mode,
          };
        }
        case 'off': {
          return {
            iconModal: <PowerRCIcon color={colors.Black} />,
            reasonsList: [
              RemoteControlReason.COLD,
              RemoteControlReason.HOT,
              RemoteControlReason.MAINTENANCE,
              RemoteControlReason.OTHER,
            ],
            titleModal: 'Desligar Máquina',
            mode,
          };
        }
        case 'economyModeDisabled': {
          return {
            iconModal: <EnergySavingIcon />,
            reasonsList: [
              RemoteControlReason.COLD,
              RemoteControlReason.HOT,
              RemoteControlReason.OTHER,
            ],
            titleModal: 'Desligar Modo Economia',
            mode,
          };
        }
      }
    });

    setOpenReasonModal(true);
  }

  function onCloseReasonModal(): void {
    setOpenReasonModal(false);
  }

  return {
    openReasonModal,
    onOpenReasonModal,
    onCloseReasonModal,
    ...options,
  };
}
